import buildRoute from './buildRoute'

export const getSignalList = async () => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'universal-signal-lists',
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

const signalListRoute = {
    getSignalList,
}

export default signalListRoute
